import React, {memo, useMemo, type RefObject} from 'react'
import {getDiffHunksData} from '../../helpers/hunk-data-helpers'
import type {ClientDiffLine, DiffLine, FileDiffReference} from '../../types'
import {SimpleUnifiedDiffRow} from './SimpleUnifiedDiffRow'
import {useDiffLinesActions, useGetFirstLineSelectionOnDrag} from '../../stores/selectors'
import {useGridNavigation} from '../../hooks/use-grid-navigation'
import type {DiffAnchor} from '@github-ui/diffs/types'

export const SimpleUnifiedDiffLines = memo(function SimpleUnifiedDiffLines({
  diffAnchor,
  diffLines,
  filePath,
  tableRef,
  avatarURL,
  userLogin,
  viewerCanApplySuggestion,
  handleMouseDownOnNumberCell,
  handleMouseEnterCell,
  handleMouseUpRow,
  handleMouseLeaveAddCommentButton,
  handleMouseDownAddCommentButton,
  copilotChatReference,
  viewerCanComment,
  shouldDisplayComments,
}: {
  diffAnchor: DiffAnchor
  diffLines: DiffLine[]
  filePath: string
  tableRef: RefObject<HTMLTableElement | null>
  avatarURL?: string
  userLogin?: string
  viewerCanApplySuggestion?: boolean
  handleMouseDownOnNumberCell: (e: React.MouseEvent) => void
  handleMouseEnterCell: (e: React.MouseEvent) => void
  handleMouseUpRow: () => void
  handleMouseLeaveAddCommentButton: (e: React.MouseEvent) => void
  handleMouseDownAddCommentButton: (e: React.MouseEvent) => void
  copilotChatReference?: FileDiffReference
  viewerCanComment?: boolean
  shouldDisplayComments?: boolean
}) {
  // TODO: move this to the store? would need to be updated as context lines were added though.
  const hunksData = useMemo(() => getDiffHunksData(diffLines), [diffLines])
  const {addLineToSelection, clearSelectedLines, selectMultipleLines} = useDiffLinesActions()
  const getfirstLineSelectionOnDrag = useGetFirstLineSelectionOnDrag()

  useGridNavigation({
    addLineToSelection,
    clearSelectedLines,
    containerRef: tableRef,
    fileAnchor: diffAnchor,
    getfirstLineSelectionOnDrag,
    isSplitDiff: false,
    leftLines: diffLines as unknown as ClientDiffLine[],
    selectMultipleLines,
    disabled: false,
  })

  return diffLines.map((diffLine, index) => {
    const key = `unified-diff-row-l:${diffLine.left}-r:${diffLine.right}-b:${diffLine.blobLineNumber}`

    const nextDiffLine = diffLines[index + 1]
    const prevDiffLine = diffLines[index - 1]
    return (
      <SimpleUnifiedDiffRow
        hunksData={hunksData}
        diffLine={diffLine}
        nextDiffLine={nextDiffLine}
        prevDiffLine={prevDiffLine}
        filePath={filePath}
        key={key}
        handleMouseDownOnNumberCell={handleMouseDownOnNumberCell}
        handleMouseEnterCell={handleMouseEnterCell}
        handleMouseUpRow={handleMouseUpRow}
        handleMouseLeaveAddCommentButton={handleMouseLeaveAddCommentButton}
        handleMouseDownAddCommentButton={handleMouseDownAddCommentButton}
        copilotChatReference={copilotChatReference}
        avatarURL={avatarURL}
        userLogin={userLogin}
        viewerCanApplySuggestion={viewerCanApplySuggestion}
        viewerCanComment={viewerCanComment}
        shouldDisplayComments={shouldDisplayComments}
      />
    )
  })
})
